/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: @loopback/repository-json-schema#Optional<Omit<BusinessUnit, \'id\'>, \'companyId\'>, schemaOptions: { title: \'NewBusinessUnitInCompany\', exclude: [ \'id\' ], optional: [ \'companyId\' ] })
 */
export interface NewBusinessUnitInCompany { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    /**
     * The name business unit
     */
    name: string;
    /**
     * The code business unit
     */
    code?: string;
    description?: string;
    logoUrl?: string;
    color?: string;
    companyId?: string;
}

